/* eslint-disable camelcase */
// node modules
import React from 'react';
import { gql } from '@apollo/client';
import HeadContent from 'components/HeadContent';

// app modules: actions
import { setAdvertVisibility } from 'actions/adverts';

// app modules: components
import Layout from 'components/Layout';
import Book from 'components/Book';

// app modules: services
import formatter from 'services/formatter';
import { isApp } from 'services/environment';

const BOOK_QUERY = gql`
  query GetBook($isbn: String, $country: String, $platform: Platform) {
    Book(isbn: $isbn) {
      advertising_opt_out
      alacarte
      alacarte_available(country: $country)
      authors {
        id
        first_name
        last_name
        is_author
      }
      awards {
        result
        name
        image
        awardUrl
        sortingOrder
      }
      categories {
        id
        title
        type
      }
      ckbk_blurb
      coming_soon
      ean
      free_scan_url
      hardcopy_link(country: $country, platform: $platform) {
        url
        service
      }
      image_credit
      image_name
      image_permission
      indexable
      isbn
      licensed
      publication_date
      publisher_blurb
      publisher_main
      ranking_recommendations
      recommendations {
        comment
        ranking
        person {
          id
          first_name
          last_name
          title
          avatar_name
          is_author
        }
      }
      signature_
      title
      title_short
    }
    FeatureToggles {
      id
      enabled
      user_permission
    }
  }
`;

async function action({ client, query, store, isGoogleBot }, params) {
  const { user } = store.getState();
  const { data } = await client.query({
    query: BOOK_QUERY,
    variables: {
      isbn: params.id,
      country: user.geolocation.countryCode,
      platform: isApp() ? 'app' : 'web',
    },
  });

  const title = `${data.Book.title} by ${formatter.authorsList.toString(data.Book.authors)}`;
  let description = '';
  const { ckbk_blurb, publisher_blurb, indexable } = data.Book;

  if (ckbk_blurb) {
    description = ckbk_blurb;
  } else if (publisher_blurb) {
    description = publisher_blurb;
  } else if (indexable) {
    description = `Members of ckbk have access to the full content of ${title}, and hundreds of other classic and contemporary cookbooks`;
  }
  if (data.Book.advertising_opt_out) {
    store.dispatch(setAdvertVisibility(false));
  }

  return {
    chunks: ['book'],
    description,
    navigation: {
      heading: 'Books',
      section: 'Books',
      left: 'back',
    },
    component: (
      <Layout>
        <HeadContent
          contents={{
            title,
            description,
          }}
        />
        <Book book={data.Book} debug={!!query.debug} forceSsr={isGoogleBot} />
      </Layout>
    ),
  };
}

export default action;
